import React from 'react';
/*import Blog from '../components/MainContent/Blog';*/
import HotPick from '../components/MainContent/HotPick';
import WorksTest from '../components/MainContent/WorksTest';
import About from '../components/MainContent/About';
import SiteLogo from '../assets/images/icon/site_logo.svg';

function Home() {
  return (
    <main className="main">
         <a className="site-logo-sp pc-none" href="/">
        <img
          src={SiteLogo}
          alt="津田千穂のポートフォリオサイトのロゴ"
        />
      </a>
      <HotPick />  
      <WorksTest /> 
      <About />
      {/* <Blog /> */}
    </main>
  );
}

export default Home;